













































































































































import { Component, Vue } from 'vue-property-decorator';

@Component({
  metaInfo() {
    return {
      title: `${this.$t('meta.partnersTitle')}`,
      htmlAttrs: {
        lang: this.$root.$i18n.locale
      },
      meta: [
        {
          name: 'description',
          content: `${this.$t('meta.partnersDescription')}`
        },
        {
          name: 'og:title',
          content: `${this.$t('meta.partnersTitle')}`
        },
        {
          name: 'og:description',
          content: `${this.$t('meta.partnersDescription')}`
        },
        {
          name: 'twitter:title',
          content: `${this.$t('meta.partnersTitle')}`
        },
        {
          name: 'twitter:description',
          content: `${this.$t('meta.partnersDescription')}`
        }
      ]
    }
  }
})
export default class Partners extends Vue {

}
